// extracted by mini-css-extract-plugin
export default {"container":"SelectableCard_container__kvFuL","image":"SelectableCard_image__ZkwZz","skeleton":"SelectableCard_skeleton__WARM5","label":"SelectableCard_label__YilTn"};